# Since api.js runs only when window.BuildOut is empty,
# Ensure this file is not loaded before it.
window.BuildOut ||= {}

readyHandler = ->
  do ->
    banner = document.getElementById('js-cookie-banner')
    cookieName = banner?.getAttribute('data-cookie-name')
    setPreferencesCallbacks = []
    bucketTools = if banner then JSON.parse(banner.getAttribute('data-bucket-tools') || '{}') else {}
    bucketDefaults = if banner then JSON.parse(banner.getAttribute('data-bucket-defaults') || '{}') else {}
    region = banner?.getAttribute('data-region')

    # Backward compat: map old bucket name to new
    BUCKET_ALIASES = { 'analytics': 'performance_analytics' }

    resolveBucketKey = (key) ->
      BUCKET_ALIASES[key] || key

    grabCookiesFromThirdParty = (allPreferences) ->
      preferencesToGrab = JSON.parse(document.getElementById('js-cookie-banner')?.getAttribute('data-cookies-for-consent-control') || '[]')
      preferences = preferencesToGrab.reduce((accumulator, currentKey) ->
        if allPreferences.hasOwnProperty(currentKey)
          accumulator[currentKey] = allPreferences[currentKey]
        return accumulator
      , {})
      setPreferenceCookie(preferences)

    handleHubspotCookieConsent = ->
      window.addEventListener('message', (event) ->
        eventName = event.data[0]
        data = event.data[1]

        if eventName == 'hubSpotCallback'
          grabCookiesFromThirdParty(data.categories)
      )

      window.parent.postMessage(['hubspotReady'], '*')

    handleCookieYesConsent = ->
      window.addEventListener('message', (event) ->
        eventName = event.data[0]
        data = event.data[1]

        if eventName == 'cookieYesCallback' && data.isUserActionCompleted
          grabCookiesFromThirdParty(data.categories)
      )

      window.parent.postMessage(['cookieYesReady'], '*')

    handleValidCookieConsentOption = (cookieConsentOption) ->
      switch cookieConsentOption
        when "hubspot" then handleHubspotCookieConsent()
        when "cookieYes" then handleCookieYesConsent()

    parseCookieByName = (name) ->
      nameMatcher = name + "="
      cookieJar = document.cookie.split(";")

      for cookie in cookieJar
        while cookie.charAt(0) == " "
          cookie = cookie.substring(1, cookie.length)

        if cookie.indexOf(nameMatcher) == 0
          return cookie.substring(nameMatcher.length, cookie.length)

      null

    getCookie = (name) ->
      getCookieFromParent = (name, resolve) ->
        getMessageFromParent = (event) ->
          eventName = event.data[0]
          data = event.data[1]
          if eventName == 'getCookieResponse'
            window.removeEventListener('message', getMessageFromParent)
            resolve(data)

        window.addEventListener('message', getMessageFromParent)
        window.parent.postMessage(['getCookie', name], '*')

      new Promise (resolve, reject) ->
        if cookieStoredInParent()
          getCookieFromParent(name, resolve)
        else
          resolve(parseCookieByName(name))

    cookieStoredInParent = ->
      # check if in iframe since we also use this logic for the main BO app
      # make sure to check for safari on frontend since we render this on the backend for plugin listings
      # Previously crios was included in the below 'isSafari' variable. This was removed because crios was preventing
      # cookies from being stored. We removed it from the list so users do not have to accept cookies for every property
      # they visit.
      isSafari = /^((?!chrome|android|phantomjs|fxios|qq|qqbrowser|opera|opr|gsa|SogouMobileBrowser|bSE|AlipayClient|Maxthon|SputnikBrowser|YaBrowser|DuckDuckGo|MiuiBrowser|HuaweiBrowser|SamsungBrowser).)*safari/i.test(navigator.userAgent)
      isEdge = /((?:Edge|Edg|EdgiOS|EdgA)\/[\d.]+|Trident\/8)/i.test(navigator.userAgent)
      isSafari && !isEdge && window.self != window.top

    showBanner = ->
      el = document.getElementById('js-cookie-banner')
      return unless el
      el.classList.remove('d-none', 'hidden')
      el.classList.add('d-block', 'show')

    hideBanner = ->
      el = document.getElementById('js-cookie-banner')
      return unless el
      el.classList.add('d-none', 'hidden')
      el.classList.remove('d-block', 'show')

    # Modal helpers that work with both Bootstrap 5 (vanilla) and Bootstrap 4 (jQuery)
    showModal = (el) ->
      return unless el
      if window.bootstrap?.Modal
        window.bootstrap.Modal.getOrCreateInstance(el).show()
      else if window.jQuery
        window.jQuery(el).modal('show')

    hideModal = (el) ->
      return unless el
      if window.bootstrap?.Modal
        instance = window.bootstrap.Modal.getInstance(el)
        if instance
          instance.hide()
          return
      if window.jQuery?.fn?.modal
        window.jQuery(el).modal('hide')
        return
      # Fallback: trigger the close button which Bootstrap handles natively
      closeBtn = el.querySelector('[data-bs-dismiss="modal"], [data-dismiss="modal"]')
      if closeBtn
        closeBtn.click()
        return
      # Last resort: manually hide
      el.classList.remove('show')
      el.style.display = 'none'
      el.setAttribute('aria-hidden', 'true')
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
      backdrop = document.querySelector('.modal-backdrop')
      backdrop?.remove()

    if cookieStoredInParent()
      # only anonymous mode is supported, so banner is pointless
      document.getElementById('js-cookie-banner')?.removeAttribute('data-enabled')
      hideBanner()

    window.BuildOut.cookieStoredInParent = cookieStoredInParent

    getPreferencesFromCookies = ->
      new Promise (resolve, reject) ->
        resolve() unless cookieName
        getCookie(cookieName).then (cookieVal) ->
          resolve() unless cookieVal
          try
            storedPreferencesJSON = decodeURIComponent(cookieVal)
            resolve(JSON.parse(storedPreferencesJSON))
          catch
            resolve()

    setThirdPartyCookie = (craftedCookie) ->
      document.cookie = craftedCookie

    setFirstPartyCookie = (craftedCookie) ->
      window.parent.postMessage(['setCookie', craftedCookie], '*')

    setPreferenceCookie = (preferences) ->
      return null unless cookieName

      # Read old prefs synchronously (for callback comparison)
      origPrefs = {}
      unless cookieStoredInParent()
        rawCookie = parseCookieByName(cookieName)
        if rawCookie
          try
            origPrefs = JSON.parse(decodeURIComponent(rawCookie)) || {}
          catch
            origPrefs = {}

      # Build and write cookie synchronously
      cookieVal = JSON.stringify(preferences)
      cookieAttrs = "path=/; "
      # Chrome Note: this means you must use https to test in a third-party context
      cookieAttrs += if location.protocol == 'https:' then 'Partitioned; SameSite=None; Secure' else 'SameSite=Lax'
      oneYearExpiration = 31536000
      craftedCookie = "#{cookieName}=#{encodeURIComponent(cookieVal)}; #{cookieAttrs}; max-age=#{oneYearExpiration}"
      if cookieStoredInParent() then setFirstPartyCookie(craftedCookie) else setThirdPartyCookie(craftedCookie)

      # Fire callbacks synchronously
      try
        setPreferencesCallbacks.forEach (callback) ->
          if typeof callback == 'function'
            # Don't pass the actual prefs, to abstract `ALL` handling
            callback(buildIsOptedIn(origPrefs), buildIsOptedIn(preferences))
      catch
        null

    # Build the full "accept all" preferences object with all tool keys set to true
    buildAcceptAllPrefs = ->
      prefs = { necessary: true }
      for bucketKey, toolKeys of bucketTools
        prefs[bucketKey] = true
        for toolKey in toolKeys
          prefs[toolKey] = true
      prefs

    # Build the full "reject all" preferences object with only necessary true
    buildRejectAllPrefs = ->
      prefs = { necessary: true }
      for bucketKey, toolKeys of bucketTools
        if bucketKey == 'necessary'
          prefs[bucketKey] = true
        else
          prefs[bucketKey] = false
          for toolKey in toolKeys
            prefs[toolKey] = false
      prefs

    buildIsOptedIn = (prefs) ->
      (key) ->
        return true if prefs.ALL
        # Check tool-level key first
        toolVal = prefs[key]
        return !!toolVal if toolVal != undefined && toolVal != null
        # Fall back to bucket key (with alias resolution)
        resolvedKey = resolveBucketKey(key)
        !!prefs[resolvedKey]

    # Collect preferences from modal checkboxes (both category and tool level)
    collectModifiablePreferences = ->
      prefs = {}
      # Collect category-level checkboxes
      Array.from(document.querySelectorAll('#js-cookie-settings .cookie-category-checkbox:not(:disabled)')).forEach (elem) ->
        prefs[elem.name] = elem.checked
      # Collect tool-level checkboxes
      Array.from(document.querySelectorAll('#js-cookie-settings .cookie-detail-checkbox:not(:disabled)')).forEach (elem) ->
        prefs[elem.name] = elem.checked
      # Always include necessary
      prefs.necessary = true
      prefs

    # Update a category checkbox to reflect the state of its children:
    # all checked → checked, none checked → unchecked, some checked → indeterminate
    updateCategoryIndeterminate = (categoryCheckbox) ->
      return if categoryCheckbox.disabled
      bucketKey = categoryCheckbox.getAttribute('data-bucket')
      children = Array.from(document.querySelectorAll("#js-cookie-settings .cookie-detail-checkbox[data-parent-bucket='#{bucketKey}']:not(:disabled)"))
      return unless children.length
      checkedCount = children.filter((c) -> c.checked).length
      categoryCheckbox.checked = checkedCount == children.length
      categoryCheckbox.indeterminate = checkedCount > 0 && checkedCount < children.length

    # Sync all category checkboxes with their children's state
    syncAllCategoryStates = ->
      Array.from(document.querySelectorAll('#js-cookie-settings .cookie-category-checkbox:not(:disabled)')).forEach (elem) ->
        updateCategoryIndeterminate(elem)

    # Sync category checkbox with its child tool checkboxes
    syncCategoryToChildren = (categoryCheckbox) ->
      bucketKey = categoryCheckbox.getAttribute('data-bucket')
      isChecked = categoryCheckbox.checked
      categoryCheckbox.indeterminate = false
      childCheckboxes = document.querySelectorAll("#js-cookie-settings .cookie-detail-checkbox[data-parent-bucket='#{bucketKey}']:not(:disabled)")
      Array.from(childCheckboxes).forEach (child) ->
        child.checked = isChecked

    # Sync child tool checkbox state back to parent category
    syncChildToCategory = (childCheckbox) ->
      bucketKey = childCheckbox.getAttribute('data-parent-bucket')
      categoryCheckbox = document.querySelector("#js-cookie-settings .cookie-category-checkbox[data-bucket='#{bucketKey}']")
      updateCategoryIndeterminate(categoryCheckbox) if categoryCheckbox

    # Caution: Don't return from enclosing IIFE until global functions are defined!

    # If the user explicitly made a choice, returns opt-in status.
    # If the user hasn't made a choice yet, return false.
    # NOTE: It doesn't make sense to call this for non-privacy-regulated regions
    window.BuildOut.cookiePreferenceOptedIn = (key) ->
      getPreferencesFromCookies().then (prefs) ->
        return false unless prefs
        return true if prefs.ALL
        # Check tool-level key first
        toolVal = prefs[key]
        return !!toolVal if toolVal != undefined && toolVal != null
        # Fall back to bucket key (with alias resolution)
        resolvedKey = resolveBucketKey(key)
        !!prefs[resolvedKey]

    # If there are many or long-running, make them async
    window.BuildOut.addSetPreferenceCookieCallback = (callback) ->
      setPreferencesCallbacks.push callback

    do ->
      # other code that can register callbacks to run after the global functions are defined
      origQueue = (window.cookiePrefsInitQueue ||= [])
      window.cookiePrefsInitQueue = { push: (callback) -> callback() }
      origQueue.forEach (callback) ->
        callback()

    return unless cookieName

    getPreferencesFromCookies().then (cookiePreferences) ->
      return if cookiePreferences

      cookieConsentOption = document.getElementById('js-cookie-banner')?.getAttribute('data-consent-cookie-control')
      validCookieConsentOptions = ["hubspot", "cookieYes"]
      if cookieConsentOption && validCookieConsentOptions.includes(cookieConsentOption)
        handleValidCookieConsentOption(cookieConsentOption)
      else if navigator.globalPrivacyControl
        setPreferenceCookie(buildRejectAllPrefs())
      else
        # See also cookieStoredInParent
        bannerEl = document.getElementById('js-cookie-banner')
        if bannerEl?.hasAttribute('data-enabled')
          showBanner()

    # Sync modal checkboxes with saved cookie preferences when modal opens
    syncModalWithSavedPreferences = ->
      getPreferencesFromCookies().then (prefs) ->
        if prefs
          # Determine the effective state for a given key
          isEnabled = (key) ->
            return true if prefs.ALL
            val = prefs[key]
            return val unless val == undefined || val == null
            # Fall back to bucket defaults from data attribute
            bucketDefaults[key]

          # Update category checkboxes
          Array.from(document.querySelectorAll('#js-cookie-settings .cookie-category-checkbox:not(:disabled)')).forEach (elem) ->
            elem.checked = !!isEnabled(elem.name)

          # Update detail checkboxes
          Array.from(document.querySelectorAll('#js-cookie-settings .cookie-detail-checkbox:not(:disabled)')).forEach (elem) ->
            parentBucket = elem.getAttribute('data-parent-bucket')
            # Check tool-level pref first, then bucket-level, then default
            toolVal = prefs[elem.name]
            if toolVal != undefined && toolVal != null
              elem.checked = !!toolVal
            else
              elem.checked = !!isEnabled(parentBucket)

        # Always sync indeterminate state (works with or without saved prefs)
        syncAllCategoryStates()

    # Sync checkboxes whenever the modal is shown (works with both BS4 and BS5)
    modalEl = document.getElementById('js-cookie-settings')
    modalEl?.addEventListener 'show.bs.modal', -> syncModalWithSavedPreferences()
    # Bootstrap 4 fires modal events via jQuery; native addEventListener won't catch these
    if window.jQuery && modalEl
      window.jQuery(modalEl).on 'show.bs.modal', -> syncModalWithSavedPreferences()

    # Banner button handlers
    document.getElementById('js-cookie-banner-settings')?.addEventListener 'click', (event) ->
      event.preventDefault()
      hideBanner()
      showModal(document.getElementById('js-cookie-settings'))

    document.getElementById('js-cookie-banner-reject-all')?.addEventListener 'click', ->
      setPreferenceCookie(buildRejectAllPrefs())
      hideBanner()

    document.getElementById('js-cookie-banner-accept-all')?.addEventListener 'click', ->
      setPreferenceCookie(buildAcceptAllPrefs())
      hideBanner()

    # Modal button handlers
    # Modal close is handled by data-dismiss/data-bs-dismiss attributes on the buttons
    document.getElementById('js-cookie-settings-confirm')?.addEventListener 'click', ->
      setPreferenceCookie(collectModifiablePreferences())
      hideBanner()

    document.getElementById('js-cookie-modal-reject-all')?.addEventListener 'click', ->
      setPreferenceCookie(buildRejectAllPrefs())
      hideBanner()

    document.getElementById('js-cookie-modal-accept-all')?.addEventListener 'click', ->
      setPreferenceCookie(buildAcceptAllPrefs())
      hideBanner()

    # Category-tool checkbox synchronization
    document.addEventListener 'change', (event) ->
      if event.target.matches('#js-cookie-settings .cookie-category-checkbox:not(:disabled)')
        syncCategoryToChildren(event.target)

    document.addEventListener 'change', (event) ->
      if event.target.matches('#js-cookie-settings .cookie-detail-checkbox:not(:disabled)')
        syncChildToCategory(event.target)

# Support both jQuery document-ready and vanilla DOMContentLoaded
if typeof jQuery != 'undefined'
  jQuery(readyHandler)
else if document.readyState == 'loading'
  document.addEventListener('DOMContentLoaded', readyHandler)
else
  readyHandler()
